/**
 * 奖励规则详情
 */
import React, { useState, useEffect, memo } from 'react';
import { Modal, Button } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './RewardShowModal.module.scss';
import model from '@/reducers/system/operatingrule/model';
import { regFenToYuan, } from '@/util/money';


const RewardShowModal = ({
    getRewardRuleDetail,
    getCleanDetail,
    closeMode,
    details,
    data,
    ...restProps
}) => {
    const [titleTag, setTitleTag] = useState(restProps.title);
    const [visible, setVisible] = useState(restProps.visible);
    const [confirmLoading, setConfirmLoading] = useState(false);

    useEffect(() => {
        getRewardRuleDetail({ id: data });//详情
        return () => {
            getCleanDetail();
        };
    }, []);

    //关闭modal
    const _handleCancel = () => {
        setVisible(false);
        closeMode();
    };

    const {
        name,
        gmtStart,
        gmtEnd,
        rewardValue,
        lvNum,
        triggerType,
        triggerConditionResp: {
            userPraiseNum,
            merchantPraiseNum,
            deliveryAmount,
            freeOrderNum,
        } = {},
    } = details;


    return (
        <Modal
            width={600}
            centered
            title={<div className={styles.showTitle}>{titleTag}</div>}
            visible={visible}
            confirmLoading={confirmLoading}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
            footer={<Button onClick={_handleCancel}>返回</Button>}
        >
            <div className={styles.container}>
                <div className={styles.colonTitle}>奖励内容</div>
                <div className={styles.itemContent}>
                    <div className={styles.label}>
                        <label>奖励名称 ：</label>
                        <span>{name}</span>
                    </div>
                    <div className={styles.label}>
                        <label>起止日期 ：</label>
                        <span>{gmtStart} ~ {gmtEnd}</span>
                    </div>
                </div>
                <div className={styles.colonTitle}>奖励方式</div>
                <div className={styles.itemContent}>
                    <div className={styles.label}>
                        <label>奖励现金 ：</label>
                        <span>{regFenToYuan(rewardValue)}元</span>
                    </div>
                    <div className={styles.label}>
                        <label>奖等级分 ：</label>
                        <span>{lvNum}分</span>
                    </div>
                </div>
                <div className={styles.colonTitle}>触发条件</div>
                {triggerType == 'COMPOSITE' && <div className={styles.condition}>
                    <h6>用户好评大于等于{userPraiseNum == '' ? 0 : userPraiseNum}次；</h6>
                    <h6>商户好评大于等于{merchantPraiseNum == '' ? 0 : merchantPraiseNum}次；</h6>
                </div>}
                {triggerType == 'RANDOM' && <div className={styles.condition}>
                    <h6>配送金额小于等于{deliveryAmount == '' ? 0 : regFenToYuan(deliveryAmount)}元；</h6>
                    <h6>每{freeOrderNum == '' ? 0 : freeOrderNum}单奖励1单；</h6>
                </div>}
            </div>
        </Modal>
    );

};

RewardShowModal.propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 弹框入参
    visible: PropTypes.bool, // 是否显示弹框
    closeMode: PropTypes.func, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题

    details: PropTypes.object,
    getRewardRuleDetail: PropTypes.func,//详情数据(action)
    getCleanDetail: PropTypes.func,//清除详情数据(action)
};

const mapStateToProps = (state) => {
    return {
        details: state.operatingrule.details,
    };
};

export default connect(mapStateToProps, model.actions)(memo(RewardShowModal));